<page-section sectionTitle="Experience">
  <div class="col">
    <app-timeline [timelineItems]="positions" [showDetailedToggle]="true"></app-timeline>
  </div>
</page-section>
